import React, { useEffect, useState } from 'react'
import "./NotificationList.css"
import Navbar from '../../appShell/Navbar/Navbar'
import Sidebar from '../../appShell/Sidebar/Sidebar'
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Navigate, useNavigate } from 'react-router-dom';
import { handleMenuSelection, searchFunction } from '../../utils/utils';
import CustomDatatableNotifications from '../../components/CustomDatatableNotifications/CustomDatatableNotifications';
import { getNotifications } from '../../services/http';
import Loader from '../../components/Loader/Loader';

const NotificationList = () => {


  const dispatch = useDispatch();
  const states = useSelector((state) => state, shallowEqual);
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const [totalPage, setTotalPage] = useState(1);
  const [notifsList, setNotifsList] = useState([]);

  const [displayLoader, setDisplayLoader] = useState(true);


  useEffect(async () => {
    dispatch({
      type: "SET",
      key: "breadcrumbContent",
      payload: {
        firstLevelText: "Notifications", firstLevelLink: "/notifications", secondLevelText: "", secondLevelLink: "", thirdLevelText: "", thirdLevelLink: ""
      }
    });
    handleMenuSelection("notifications", dispatch, states);
    // handleSubMenuSelection("institutions-categories", dispatch)
  }, [])


  // To load notifs list in redux state
  useEffect(async () => {
    let notif_list_response = await getNotifications(states.userToken.access_token, pageNumber);
    const perPageValue = notif_list_response?.data?.per_page
    setPerPage(perPageValue)
    const total = notif_list_response?.data?.total;
    setTotalPage(Math.ceil(total / perPageValue))
    
    console.log("notif_list_response ", notif_list_response.data.data)
    setNotifsList(notif_list_response?.data.data)
    dispatch({
      type: "SET",
      key: "notifList",
      payload: notif_list_response?.data.data,
    });
    setDisplayLoader(false);
  }, [])

  const handleSearchChange = (e) => {
    console.log(e.currentTarget.value)
    setSearch(e.currentTarget.value)
  }

  const changePage = ({ selected }) => {
    let currentPage = selected + 1;
    setPageNumber(currentPage)
}

  const tableColumns = [
    { id: "1", label: "#" },
    { id: "2", label: "Date et heure" },
    { id: "3", label: "Message de notifications" },
    { id: "4", label: "Type" },
    { id: "5", label: "Statut" },
    { id: "6", label: "Actions" },
  ]

  useEffect(() => {
    console.log("notifList ", states.notifList)
  
   
  }, [states.notifList]);



  return (
    <div>
      <Navbar />
      <div className="main-container" id="container">
        <Sidebar />

        <div id="content" className="main-content">
          <div className="layout-px-spacing">

            <div className="row layout-top-spacing">
              <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
              </div>
            </div>
            {/* Start  */}

            <h2 className="mb-3 text-left">Liste des notifications</h2>
            {displayLoader == false ?
            <div className="widget widget-content widget-content-area">
              <div className="dataTables_wrapper  dt-bootsrap4">
                <div className="dt--top-section container-fluid mt-4 py-3 px-3">
                  <div className="row">
                    <div className="col-12 col-sm-6 d-flex justify-content-sm-start justify-content-center mt-sm-0 mt-3 mb-3">
                      <form class="form-inline justify-content-center search-input-container">
                        <div class="w-100 d-flex flex-nowrap search-input-container">
                          <input type="text" onChange={handleSearchChange} class=" form-control product-search br-30" id="input-search" placeholder="Rechercher..." />

                        </div>
                      </form>
                    </div>
                    <div className="col-12 col-sm-6 d-flex justify-content-sm-end justify-content-center mt-sm-0 mt-3 mb-3">
                      {/* <div>
                        <button className="btn btn-info" 
                                // onClick={() => handleShowNewProductModal()}
                                onClick={() => navigate("/product/new")}
                                > 
                                <BiPlusMedical className="" /> Ajouter</button>
                        <button className="btn btn-dark ml-3" onClick={goToImportScreen}><AiOutlineFileExcel className="mr-1" />Importer</button>
                      </div> */}
                    </div>
                  </div>
                </div>

                {notifsList && searchFunction(notifsList, search).length != 0 ?
                  <CustomDatatableNotifications
                    columns={tableColumns}
                    data={searchFunction(notifsList, search)}
                    changePage={changePage}
                    pageCount={totalPage}
                    pageNumber={pageNumber}
                    perPage={perPage}
                  /> : <h4 className="py-3">Aucun résultat</h4>}
              </div>
            </div> : <div style={{ marginTop: "25%" }}>
                  <Loader />
                </div>}

            {/* End */}
          </div>

        </div>
      </div>
    </div>
  )
}

export default NotificationList